const APP_ID = '520302855352586'
let API_URL = null

/*
 * If REACT_APP_BACKEND_URL is set than use this value as the backend url.
 * In other cases fall back to the defaults depending on the env.
 *
 * You can set an env variable in '.env.<production|development|test>' file
 * More about that here: https://create-react-app.dev/docs/adding-custom-environment-variables
 */
if (process.env.REACT_APP_BACKEND_URL) {
  API_URL = process.env.REACT_APP_BACKEND_URL
} else if (process.env.NODE_ENV === 'development') {
  // Usually in 'development' env the backend url is 'http://localhost:8080'
  API_URL = 'http://localhost:8080/api'
} else if (process.env.NODE_ENV === 'production') {
  // In a 'production' env the client app is usually on the same domain name as the backend
  API_URL = window.location.origin + '/api'
} else {
  console.log('********************************************')
  console.log('*                                          *')
  console.log('*                                          *')
  console.log("*     Unknown profile '" + process.env.NODE_ENV + "'!       *")
  console.log('* Please review you project configuration! *')
  console.log('*                                          *')
  console.log('*                                          *')
  console.log('********************************************')
}

function setAPIUrl(value) {
  API_URL = value
}

export { APP_ID, API_URL, setAPIUrl }
